import { debugLog } from "@/logging/log-level"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { NftFiltersMoleculeReatom } from "../filters/store.reatom"
import { NftSortMoleculeReatom } from "../sort/store.reatom"
import { NftSearchResultMoleculeReatom } from "./store.reatom"
import { clearExpiredListing, sortNotListedLast } from "./utils"

export const useNftSearchResult = () => {
  const { nftSearchQueryParamsAtom } = useMolecule(
    NftSearchResultMoleculeReatom,
  )
  const { sortAtom } = useMolecule(NftSortMoleculeReatom)
  const { statusFilter } = useMolecule(NftFiltersMoleculeReatom)
  const queryParams = nftSearchQueryParamsAtom()
  const sort = sortAtom()
  const status = statusFilter()

  debugLog(
    "🔵 [useNftSearchResult] Client query key:",
    JSON.stringify(queryParams.queryKey),
  )

  const { data, fetchNextPage, isFetchingNextPage, hasNextPage } =
    useSuspenseInfiniteQuery(queryParams)

  const nfts = useMemo(
    () =>
      sortNotListedLast(
        data.pages.flatMap((page) => page.nfts.map(clearExpiredListing)),
        sort,
        status,
      ),
    [data.pages, sort, status],
  )

  const loadNextPage = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage()
    }
  }, [isFetchingNextPage, fetchNextPage, hasNextPage])

  return useMemo(
    () => ({
      nfts,
      nextPageLoading: isFetchingNextPage,
      loadNextPage,
    }),
    [nfts, isFetchingNextPage, loadNextPage],
  )
}
